<script lang="ts">
    // import { computed, ComputedRef, onMounted, ref } from 'vue'

    // utils
    // import { uid } from '@utils'

    // assets
    // import { SmallArrowDownSVG, SmallArrowUpSVG } from '@shared/assets/vector/ui/IconsUI'

    // this is mostly for debugging, otherwise components are Anonymous
    export default {
        name: 'Input_Toggleable',
    };
</script>

<script lang="ts" setup>
    const props = withDefaults(
        defineProps<{
            type?: string;
            value: any;
            checked?: any;
            unchecked?: any;
            text?: string;
            multiple?: string;
            onChange?: (val: any) => any;
        }>(),
        {
            type: 'checkbox',
            checked: true,
            multiple: 'true',
        }
    );

    const multiple_choice = props.type !== 'checkbox' ? false : props.multiple,
        emit = defineEmits<{
            (ev: 'update:value', value: any): void;
        }>();

    // const updateCheckboxValues = (val: any) => {}

    const handleChange = () => {
        let val = props.checked !== props.value ? props.checked : props.unchecked;
        if (props.type === 'checkbox' && multiple_choice === 'true') {
            let idx = props.value.indexOf(props.checked);

            idx < 0 ? props.value.push(props.checked) : props.value.splice(idx, 1);
        } else {
            emit('update:value', val);
        }

        if (props.onChange) props.onChange(val);
    };
</script>

<template>
    <div class="fluid-toggle">
        <label class="input-wrapper">
            <input
                class="phantom"
                :type="type"
                :value="value"
                :checked="type === 'checkbox' && multiple_choice === 'true' ? value.indexOf(checked) !== -1 : checked === value"
                @change="handleChange" />
            <span class="styled-button"></span>
            <span v-if="text" class="ml-xs lg">{{ text }}</span>
        </label>
    </div>
</template>

<style>
    .fluid-toggle {
        display: flex;
    }
    .fluid-toggle .input-wrapper {
        cursor: pointer;
        margin-bottom: 0;
        align-items: center;
    }

    input.phantom {
        position: absolute;
        visibility: hidden;
        pointer-events: none;
    }

    .fluid-toggle .styled-button {
        display: block;
        position: relative;
        width: 20px;
        height: 20px;
        top: 0;
        left: 0;

        background-color: #b7b5b9;
        border-radius: 2px;

        transition: background-color 0.2s ease;
    }

    .fluid-toggle .styled-button::after {
        content: '';
        position: absolute;
        width: 0.875rem;
        height: 0.875rem;
        /* top: 0.1875rem;
   left: 0.1875rem; */
        left: 50%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        background-color: #eae9ea;
        border-radius: 1px;

        /* box-shadow: 0 0 0 0.125rem #fff inset; */
        border: 0.125rem solid #fff;

        transition-property: left, background-color;
        transition-duration: 0.2s;
        transition-timing-function: ease;
    }

    .fluid-toggle:hover .styled-button::after {
        background-color: #dddcde;
    }
    .fluid-toggle:not(.slide) input:checked ~ .styled-button::after {
        background-color: #1fa9b0;
    }

    /* slide */
    .fluid-toggle.slide .styled-button {
        width: 2.5rem;
        height: 1.25rem;
    }

    .fluid-toggle.slide .styled-button::after {
        left: 0.2rem;
        transform: translate3d(0, -50%, 0);
    }

    .fluid-toggle input:checked ~ .styled-button {
        background-color: #1fa9b0;
    }
    .fluid-toggle.slide input:checked ~ .styled-button:after {
        left: 1.4375rem;
    }

    /* rounded */
    .fluid-toggle.rounded .styled-button,
    .fluid-toggle.rounded .styled-button::after {
        border-radius: 2.5rem;
    }
</style>
